import React from 'react';
import { render } from 'react-dom';
import { Recommendations, ApplicationErrorBoundary } from 'components';
import { Provider } from 'react-redux';
import globalStore from 'state/configure-store';
import { LoadingSymbolSpinner } from 'static/script/components/recommendations/recommendation-loading-spinners';
import { recommendationsV3RequestBuilder } from 'components/recommendations/recommendation-request';
import { inViewport } from 'packages';
import 'components/recommendations/recommendations.scss';
import { MultiCurrencyBoot } from 'components';

export default initData => {
    const selector = 'vip-product-recommendations';
    const element = document.getElementById(selector);

    const Title = () => (
        <div className="mb-3" data-recommendations-title>
            <h4 className="text-center">Andra har även tittat på</h4>
        </div>
    );

    const seedItemIds = !!initData.itemId ? [initData.itemId] : null;
    const pageSize = 12;
    const quickViewEnabled = !!initData.featureSwitches['quick-view'];

    if (element) {
        const mount = target =>
            render(
                <ApplicationErrorBoundary>
                    <Provider store={globalStore}>
                        <Recommendations
                            Title={<Title />}
                            itemsPerPage={pageSize}
                            createRequestUrl={recommendationsV3RequestBuilder(
                                'VIP_Bottom',
                                pageSize,
                                seedItemIds
                            )}
                            LoadingSymbol={<LoadingSymbolSpinner />}
                            itm={{
                                source: 'vip',
                                medium: 'suggest-from-blueshift'
                            }}
                            collapseIfEmpty={true}
                            enableQuickView={quickViewEnabled}
                        />
                    </Provider>
                </ApplicationErrorBoundary>,
                target
            );

        inViewport(`#${selector}`, mount);
    }

    MultiCurrencyBoot.boot(initData);
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/view-item/similiar-items-from-blueshift-mount.js